module.exports = __webpack_public_path__ + "static/media/logo_lbe.1e7f7156.png";